import { render, staticRenderFns } from "./dashBoard.vue?vue&type=template&id=7e58a1b1&"
import script from "./dashBoard.vue?vue&type=script&lang=js&"
export * from "./dashBoard.vue?vue&type=script&lang=js&"
import style0 from "./dashBoard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dashBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSimpleTable})
